import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import fetch from '../../core/fetch';
import AboutUs from './aboutUs';

const title = "About Us";


// const query = `query getEditStaticPage ($id: Int!) {
//   getEditStaticPage (id: $id) {
//       id
//       pageName
//       content
//       metaTitle
//       metaDescription
//       createdAt
//   }
// }`;

export default async function action({ locale }) {

//   const resp = await fetch('/graphql', {
//     method: 'post',
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       query: query,
//       variables: { id: 1 },
//     }),
//     credentials: 'include',
//   });

//   const { data } = await resp.json();

  return {
    title,
    // title: data?.getEditStaticPage?.metaTitle,
    // description: data?.getEditStaticPage?.metaDescription,
    // chunk: 'about',
    component: <Layout><AboutUs /></Layout>,
  };

};
